import BindToList from "../decorators/bind-to-list"
import HotlistStorage from "../decorators/hotlist-storage"
import BindClass from "../decorators/bind-to-class"

export default class FixedTabs {

    @BindClass('hide')
    private hideFixedTabs: boolean = true

    @BindToList
    private fixedTabList: Array<any>

    @HotlistStorage
    private hotlistStorage: any

    public updateFixedTabs() {
        this.hideFixedTabs = false
        this.fixedTabList = this.hotlistStorage.lists
    }
}